import ValidationResult from "domain/types/global/validationResult";
import { CAMPANHA_RESGATE_APROVAR, AprovarPedidoActionTypes, AprovarPedidoState } from "../../../types/aprovarPedido/aprovarPedido";

const INITIAL_STATE: AprovarPedidoState = {
	mudancaStatus: {} as ValidationResult
}

export function AprovarPedidoReducer(state = INITIAL_STATE, action: AprovarPedidoActionTypes): AprovarPedidoState {
	switch (action.type) {
		case CAMPANHA_RESGATE_APROVAR:
			return { ...state, mudancaStatus: action.payload };
		default:
			return state
	}
}